import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ISeoTagType, SEOService } from '@app/shared/services';
import { IGift } from '@app/gifts/models/gift.interface';

@Component({
  selector: 'app-gifts-list-view',
  templateUrl: './gifts-list-view.component.html',
  styleUrls: ['./gifts-list-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GiftsListViewComponent implements OnInit {
  visitId: string;
  gifts: IGift[];

  constructor(private seoService: SEOService,
    private route: ActivatedRoute) {
    this.seoService.setSEO([
      {
        tagType: ISeoTagType.Title,
        i18nKey: 'GIFTS.LIST-VIEW.META-TITLE'
      }
    ]);
  }

  ngOnInit(): void {
    this.gifts = this.route.snapshot.data.gifts;
    this.visitId = this.route.snapshot.paramMap.get('visitId');
  }
}
